const useSeccionStore = defineStore("seccion", () => {
  // stados
  const seccion = ref({
    id: null,
    nombre: null,
    descripcion: "",
    tipo_biografia_id: null,
    titulo_capitulo: null,
    orden: 0,
  });

  const secciones = ref([]);

  // getters

  const draft = computed(() => clone(seccion.value));

  // mutations

  const clear = () => {
    seccion.value = {
      id: null,
      nombre: null,
      descripcion: "",
      tipo_biografia_id: null,
      titulo_capitulo: null,
      orden: 0,
    };
  };

  const setSecciones = (payload) => {
    if (payload) secciones.value = payload;
  };

  // actions

  const fetch = (seccion_id) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/seccions/${seccion_id}/fetch-data`)
        .then(({ data }) => {
          seccion.value = data;
          resolve(data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  };

  const fetchData = (datos) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/seccions/fetch-data`, datos)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  };

  const guardar = (datos) => {
    return new Promise((resolve, reject) => {
      if (datos.id) {
        // actualizado
        axios
          .put(`/api/seccions/${datos.id}`, datos)
          .then(({ data }) => {
            if (data.result) {
              seccion.value = data.seccion;
            }
            resolve(data);
          })
          .catch((e) => reject(e));
      } else {
        // creando
        axios
          .post(`/api/seccions`, datos)
          .then(({ data }) => {
            resolve(data);
          })
          .catch((e) => reject(e));
      }
    });
  };

  const eliminar = (seccion_id) => {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/seccions/${seccion_id}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const getSeccionesBio = (bio_id) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/biografias/${bio_id}/get-secciones`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  return {
    // states
    seccion,
    secciones,
    // getters
    draft,
    // methods or actions
    fetch,
    fetchData,
    guardar,
    eliminar,
    clear,
    getSeccionesBio,
  };
});

export default useSeccionStore;
